import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ISubscription } from 'rxjs/Subscription';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../shared/services/auth.service';
import { ApplicazioneEnum, ApplicazioneRuoloDto, RuoloEnum, UtenteDto } from '../../../shared/dto/UtenteDto';
import { environment } from '../../../../environments/environment';
import { ToastrMessagesService } from '../../../shared/services/toastr-messages.service';
import { UsersService } from '../../../shared/services';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  subscriptionUserLogin: ISubscription;
  userLogin: any;
  collapsed = true;
  consensoGdpr;
  cuaaRappresentante: string;
  abilitaFunzioneCooperative = false;
  isCensimentoAziendeAbilitato = false;
  isGestioneCooperativeAbilitato = false;
  aziendeAssociate = new Array<any>();
  isUtenteAmministratore = false;
  isFunzionarioRegionale = false;
  isAzienda = false;
  isFunzioarioComunale = false;
  isForzeOrdine = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService,
    public http: HttpClient,
    private act: ActivatedRoute,
    private toastr: ToastrMessagesService,
    private usersService: UsersService) {

  }
  ngOnInit() {
    this.authService.clearSessionFromMenu();
    this.authService.getUserDetails()
      .subscribe({
        next: (res) => {
          this.userLogin = res.body;
          if (this.userLogin) {
            this.usersService.updateUtente(this.userLogin);
            sessionStorage.setItem('user', JSON.stringify(this.userLogin));
            /*if (this.isUtenteAmministratore) {
              this.router.navigate(['/fascicolo/cruscotto']);
            }*/
            this.setData();
            this.impostaAbilitazioni(this.userLogin);
          }
        },
        error: (e) => {
          this.toastr.showErrorMessage(e.error.text);
        }
      })
  }

  private setData() {
    const utente = JSON.parse(sessionStorage.getItem('user'));
    this.cuaaRappresentante = utente['codiceFiscale'];
    if (utente.aziendeDelegate) {
      utente.aziendeDelegate.forEach(el => {
        el.aziendeDelegate.forEach(azienda => {
          this.aziendeAssociate.push(azienda.cuaa);
        });
      });
    }
    this.isCensimentoAziendeAbilitato = true;

  }

  private impostaAbilitazioni(utente: UtenteDto[]) {

    var ruoli = utente["ruoli"];
    
    if (this.aziendeAssociate.length > 0) {
      this.isAzienda = true;
    }
    else {
      var i;
      var l;
      for (i = 0; i < ruoli.length; i++) {
        for (l = 0; l < ruoli[i].ruoli.length; l++) {
          console.log(RuoloEnum.AUAAL_FORZE_ORDINE, ruoli[i].ruoli[l].id)
          if (ruoli[i].ruoli[l].applicazione === ApplicazioneEnum.AUAAL_CLIENT && ruoli[i].ruoli[l].id === RuoloEnum.AUAAL_AMMINISTRATORE) {
            this.isUtenteAmministratore = true;
          }
          else if (ruoli[i].ruoli[l].applicazione === ApplicazioneEnum.AUAAL_CLIENT && ruoli[i].ruoli[l].id === RuoloEnum.AUAAL_FUNZIONARIO_REGIONALE) {
            this.isFunzionarioRegionale = true;
          }
          else if (ruoli[i].ruoli[l].applicazione === ApplicazioneEnum.AUAAL_CLIENT && ruoli[i].ruoli[l].id === RuoloEnum.AUAAL_FUNZIONARIO_COMUNALE) {
            this.isFunzioarioComunale = true;
          }
          else if (ruoli[i].ruoli[l].applicazione === ApplicazioneEnum.AUAAL_CLIENT && ruoli[i].ruoli[l].id === RuoloEnum.AUAAL_FORZE_ORDINE) {
            this.isForzeOrdine = true;
          }
        }
      }
    }

  }

  logout() {
    // this.authService.clearSession();
    // this.cookieService.deleteAll('/', '/');
    // document.cookie = 'access_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    window.location.href = environment.cisia;
  }
  goTo(nome: String) {
    if (nome == 'fascicolo') {
      if (this.isAbilitatoAllAziende()) {
        this.router.navigate(['fascicolo']);
      } else if (this.aziendeAssociate.length === 1) {
        this.userLogin['cuaa'] = this.aziendeAssociate[0];
        sessionStorage.setItem('userLogin', this.userLogin);
        sessionStorage.setItem('cuaaSelezionato', this.aziendeAssociate[0]);
        this.router.navigate(['/fascicolo/anagrafica'])
      } else if (this.aziendeAssociate.length > 1) {
        this.router.navigate(['selezionecuaa']);
      } else {
        this.router.navigate(['fascicolo']);
      }
    } else if (nome == 'cruscotto') {
      this.router.navigate(['/fascicolo/cruscotto']);
    }
    else {
      this.router.navigate(['/menu']);
    }
  }

  isAbilitato() {
 // Francesco 14/10/2024   
 //   return this.isAzienda || this.isForzeOrdine || this.isFunzioarioComunale || this.isFunzionarioRegionale;
    return this.isAzienda || this.isForzeOrdine || this.isFunzioarioComunale || this.isFunzionarioRegionale;
  }

  isAbilitatoAllAziende() {
    // Francesco 14/10/2024   
    //   return this.isAzienda || this.isForzeOrdine || this.isFunzioarioComunale || this.isFunzionarioRegionale;
       return this.isForzeOrdine || this.isFunzioarioComunale || this.isFunzionarioRegionale;
     }

}
